import fetchModels from "../../mixin/store/api/fetchModels"
import changeModel from "@/mixin/store/api/changeModel";

export default {
    actions: {
        fetchOrdersCustomer(context, isArchived = false) {
            return fetchModels(context, 'orders?isArchived=' + isArchived, 1, 'updateOrders')
        },
        changeOrderStatus(context, order) {
            return changeModel(context, 'orders/' + order.id, order, null)
        },
        changeOrderDeliveredAt(context, order) {
            return changeModel(context, 'orders/delivered/' + order.id, order, null)
        },
    },
    mutations: {
        updateOrders(state, orders) {
            state.orders = orders
        },
    },
    state: {
        orders: {
            models: [],
            totalItems: 0
        },
    },
    getters: {
        getOrdersCustomer(state) {
            return state.orders
        },
    },
}
